import React from 'react'
import { Products } from "./Products";


export default function Product() {
  return (
    <div >
     <h1 className='Head2'>We have a variety of products</h1>
      <Products/>

        
    </div>
  )
}
